import clsx from 'clsx';
import React from 'react';

import type { CurrencyCode } from '@fragment/types/currencyCodes';

import { type TextSizeType, sizeToTextClassName } from '../utils';

const formatCurrency = (
  amount: number,
  currencyPrecision: number,
  currencyCode: CurrencyCode
) =>
  `${(amount / 10 ** currencyPrecision).toFixed(
    currencyPrecision
  )} ${currencyCode}`;

export const CurrencyField = ({
  label,
  amount,
  currencyPrecision,
  currencyCode,
  textSize,
  align,
  width = 'fit',
  paid,
  'data-testid': dataTestId,
}: {
  label?: string;
  amount: number;
  currencyPrecision: number;
  currencyCode: CurrencyCode;
  textSize: TextSizeType;
  align: 'left' | 'right' | 'center';
  width?: 'full' | 'fit';
  paid?: boolean;
  'data-testid'?: string;
}) => (
  <span
    className={clsx(
      'flex flex-row whitespace-nowrap h-fit text-main font-FragmentMono gap-x-[1ch]',
      width === 'full' && 'w-full',
      width === 'fit' && 'w-fit',
      sizeToTextClassName[textSize],
      align === 'left' && 'justify-start',
      align === 'center' && 'justify-center text-center',
      align === 'right' && 'justify-end text-right',
      paid && 'line-through text-main-500'
    )}
    data-testid={dataTestId ?? 'currency-text-field'}
  >
    {label && <span className="text-main-500 min-w-f6">{label}</span>}
    {formatCurrency(amount, currencyPrecision, currencyCode)}
  </span>
);
